
import React from 'react'

import { IGeneralData } from '@np/np_webcomponentlib'

import { optionEnum } from '../../shared/entityOperations/EntityFormTypes'

import { Column, ListFields } from '@np/np_webcomponentlib'

import { EntityFormProps } from '../../shared/entityOperations/EntityFormTypes'

import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'

import {DataEntityType as BusinessEntityType} from '../Business/BusinessTypes'


export interface EntityType {
  [key: string]: string | number | Date | boolean |BusinessEntityType | RFRole | null; // Допускаем, что значения могут быть строками или числами
  idrfFUser: string,
  idEntityDomain: string
  idrfRole: string
}

export interface DataEntityType extends IGeneralData, EntityType {
}

export interface RFRole
{
  name: string,
  idUnique: string
}

export interface DataEntityTypeViewModel extends IGeneralData, EntityType {
  business: BusinessEntityType,
  role: RFRole,
}


//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined
}

// export const getEntityByListValues = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listValue, если оно существует
//       const valueToSet = field.listValue.length > 0 ? field.listValue[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }

export const initEntity: EntityType = {
  idrfFUser: "",
  idEntityDomain: "",
  idrfRole: ""
}







export const columnsIdrfspecification: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 5,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]





export const columnsIdrfcharacteristictype: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },


  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]




